import { AfterViewInit, Component, Input, OnInit, ViewChild } from '@angular/core';
import { ComponentService } from '../../services/component.service';
import { DxChartComponent, DxContextMenuComponent, DxPieChartComponent } from 'devextreme-angular';

import { v4 as uuidv4 } from 'uuid';

@Component({
  selector: 'app-widget-giacenza',
  templateUrl: './widget-giacenza.component.html',
  styleUrls: ['./widget-giacenza.component.css']
})
export class WidgetGiacenzaComponent implements OnInit,AfterViewInit {
  @ViewChild(DxChartComponent , { static: false }) graficochart: DxChartComponent;
  @ViewChild(DxPieChartComponent,{ static: false}) graficopiechart : DxPieChartComponent; //Il grafico a torta è caratterizzato da una apposita classe per questo uso di nuovo il decorator @ViewChild

  @ViewChild(DxContextMenuComponent, { static: false }) contextMenu: DxContextMenuComponent;



  @Input() eer='150101';
  @Input() tipoCalcolo='C';
  
  //@Input() GUID='';
  targetElement;
  GUIDX;
  GUID='';
  buttonElement: any;
  isContextMenuVisible:boolean=false;
  
  descrizioneEer='IMBALLAGGI CARTA E CARTONI';
  countriesInfo;
  energySources;
  legendSettings = {
    //visible: false
    orientation: 'horizontal',  // Imposta la disposizione orizzontale
    itemTextPosition: 'right',  // Posizione del testo rispetto alla legenda
    horizontalAlignment: 'center', // Allinea orizzontalmente la legenda
    verticalAlignment: 'bottom' // Posiziona la legenda in basso
  };
  contextMenuPosition = {
    my: 'top right', 
    at: 'top left' 
};
  dettProductionData = [{
    state: 'Gennaio',
    Carico: 186.7,
    Scarico: 480.4,
  }, {
    state: 'Febbraio',
    Carico: 557.8,
    Scarico: 423.2,
  }, {
    state: 'marzo',
    Carico: 32.7,
    Scarico: 87.7,
  }, {
    state: 'Aprile',
    Carico: 87.5,
    Scarico: 78.1,
  }, {
    state: 'Maggio',
    Carico: 24.7,
    Scarico: 109.2,
  },{
    state: 'Giugno',   
    Carico: 340.1,
    Scarico: 282.9,
  },{
    state: 'Luglio',   
    Carico: 440.1,
    Scarico: 382.9,
  },{
    state: 'Agosto',   
    Carico: 140.1,
    Scarico: 682.9,
  },{
    state: 'Set',   
    Carico: 140.1,
    Scarico: 192.9,
  },{
    state: 'Ott',   
    Carico: 380.1,
    Scarico: 123.9,
  },{
    state: 'Nov',   
    Carico: 300.1,
    Scarico: 82.9,
  },{
    state: 'Dic',   
    Carico: 140.1,
    Scarico: 82.9,
  }];

 myGuid;
  data = [
    { day: 'Gen', sales: 10, salesS: 5 },
    { day: 'Feb', sales: 20, salesS: 30  },
    { day: 'Mar', sales: 30, salesS: 50  },
    { day: 'Apr', sales: 40, salesS: 20  },
    { day: 'Mag', sales: 50 , salesS: 10 },
    { day: 'Giu', sales: 10 , salesS: 90 },
    { day: 'Lug', sales: 20 , salesS: 50 },
    { day: 'Ago', sales: 30 , salesS: 80 },
    { day: 'Set', sales: 40 , salesS: 40 },
    { day: 'Ott', sales: 50 , salesS: 70 },
    { day: 'Nov', sales: 40 , salesS: 10 },
    { day: 'Dic', sales: 50 , salesS: 60 }
  ];
  PalettesItems = [
    { text: 'Ocean' },
    { text: 'Bright' },
    { text: 'Harmony Light' },
    { text: 'Pastel' },
    { text: 'Soft' },
    { text: 'Soft Pastel' },
    { text: 'Pastel' },
    { text: 'Soft' },
    { text: 'Vintage' },
    { text: 'Violet'},
    {text:'Dark Moon'} , 
    { text: 'Dark Violet'},
    { text: 'Green Mist'},
    { text: 'Soft Blue'},
    { text: 'Material' },
    { text: 'Office'},            
  ];
  palettes:string[]=[
    'Ocean', 'Bright' , 'Harmony Light' , 'Pastel' , 'Soft' , 'Soft Pastel' , 'Vintage' , 'Violet' , 'Carmine' , 'Dark Moon' , 'Dark Violet' , 'Green Mist' , 'Soft Blue' , 'Material' , 'Office'
  ];

  paletteSelezionata?:string='ocean';

  //doughnut rangeArea
tipoGrafico='bar';
  chartSize = {
    height: 200,  // Altezza in pixel
    width: 400    // Larghezza in pixel (opzionale)
  };
  types: string[] = ['line', 'stackedline', 'fullstackedline'];
  constructor(
      private componentService:ComponentService

  ) { }
  ngAfterViewInit(): void {
//    setTimeout(() => {
//       this.contextMenu.instance.option('target', "#"+this.GUID); 
//    }, 200);
    //var str=uuidv4();
    //this.GUID = str.replaceAll('-', '')
    //this.contextMenu.target="#"+this.myGuid
    //this.contextMenu.instance.option('target', "#"+this.myGuid); 
    //console.log(this.myGuid)
    //throw new Error('Method not implemented.');
  }

  ngOnInit() {

      //this.GUIDX='#'+this.GUID
   // this.myGuid=uuidv4();
   // console.log(this.myGuid)
   this.GUID="Gr"+uuidv4()
   
  }
  customizeTooltip(arg) {
    //console.log(arg);
    return { text: `${arg.argumentText}<br>${arg.seriesName}: ${arg.valueText}B` };
  }
  salvaImpostazioni(){

  }
  sciegliPalette(e: any) {
    

    this.targetElement = "#"+this.GUID;  // Aggiorna il target nel binding del template
    this.contextMenu.instance.option('target',"#"+this.GUID);  // Modifica dinamicamente il target del context menu


    this.contextMenu.instance.option('target', "#"+this.GUID);
    this.isContextMenuVisible=true;
    //this.buttonElement = e.element;
    //this.contextMenu.showAt   instance.showAt(this.buttonElement);
  }

  
  contextmenuitemClick(ev){
      //console.log(ev);
      this.paletteSelezionata= ev.itemData.text;

  }

  onValueChangedCambiaPalette(evt:any){
   
    this.paletteSelezionata = evt.value;
  }
  settaTipoGrafico(ev){
    this.tipoGrafico=ev;
  }
  apriFormConfigura(event){
    let guid = Math.random().toString().replace("0.", "");
    let InstanceDatadata={
        service:'graficiGiacenze',
        api:'',
        isEdit:false,
        remoteOperation:false,
    }
    this.componentService.setNewPopUp(guid, 'NewNicaFormComponent', {}, '1000', null, InstanceDatadata, false, true, 'Settagio Parametri')   
    this.componentService.outputComponent.subscribe(res=>{
      console.log(res)
      if(res.name=='return'){
        this.componentService.destroyCurrentOpenPopUp('NewNicaFormComponent');
      }
    })     
  }
 
}

